import { render } from "./Veranstaltungen.vue?vue&type=template&id=27b37e8b"
import script from "./Veranstaltungen.vue?vue&type=script&lang=js"
export * from "./Veranstaltungen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__